import { useQuery } from '@tanstack/react-query'

import { getServerLikesActive } from '@wwt/core/admin'

import { setsOptions } from '../options/setsOptions'

export const useSets = () => {
	const queryData = useQuery({
		...setsOptions(),
		enabled: getServerLikesActive()
	})

	return queryData
}
